import { VStack, Button, Text } from '@chakra-ui/react'
import React, { FC } from 'react'
import { useHistory } from 'react-router'
import { use100vh } from 'react-div-100vh'

const ErrorLayout: FC<{ title: any }> = ({ title, children }) => {
  const history = useHistory()
  const height = use100vh()

  return (
    <VStack
      maxW={{ md: '480px' }}
      w="full"
      mx="auto"
      pb="2.4rem"
      px="2.4rem"
      pt="1.2rem"
      h={height || undefined}>
      <VStack spacing="3rem" justify="center" flex="1">
        {children}
        <Text
          textAlign="center"
          dangerouslySetInnerHTML={{ __html: title }}
          color="black"
          fontSize="1.5rem"
        />
      </VStack>
      <Button onClick={() => history.push('/')} variant="blue" isFullWidth>
        Go Home
      </Button>
    </VStack>
  )
}

export { ErrorLayout }
